module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "dialog-demo",
    on: {
      "on-hide": function($event) {
        _vm.hideDialog()
      }
    },
    model: {
      value: (_vm.showlogindialog),
      callback: function($$v) {
        _vm.showlogindialog = $$v
      },
      expression: "showlogindialog"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px",
      "margin-bottom": "30px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/taluoshuo.png"),
      "width": "150",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn_group"
  }, [_c('div', {
    staticClass: "round_btn",
    attrs: {
      "align": "center"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/phone.png"),
      "height": "30",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "color": "white"
    }
  }, [_vm._v("手机登录")])]), _vm._v(" "), _c('div', {
    staticClass: "round_btn",
    staticStyle: {
      "background-color": "#0dbc19"
    },
    attrs: {
      "align": "center"
    },
    on: {
      "click": function($event) {
        _vm.wxLogin()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": require("../assets/wx.png"),
      "height": "30",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "color": "white"
    }
  }, [_vm._v("微信登录")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toggle),
      expression: "toggle"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "yes",
      "false-value": "no"
    },
    domProps: {
      "checked": Array.isArray(_vm.toggle) ? _vm._i(_vm.toggle, null) > -1 : _vm._q(_vm.toggle, "yes")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.toggle,
          $$el = $event.target,
          $$c = $$el.checked ? ("yes") : ("no");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.toggle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.toggle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.toggle = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("我同意并愿意遵守")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#6b6eb5"
    },
    attrs: {
      "href": "http://www.taluoshuo.com/app/xieyi.htm"
    }
  }, [_vm._v("《情感帮用户协议》")]), _vm._v("和"), _c('a', {
    staticStyle: {
      "color": "#6b6eb5"
    },
    attrs: {
      "href": "http://www.taluoshuo.com/app/yinsi.htm"
    }
  }, [_vm._v("《隐私政策》")])])])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.hideDialog()
      }
    }
  }, [_c('span', {
    staticClass: "vux-close"
  })])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0264d82a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0264d82a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tlpage/LoginDialog.vue
// module id = 251
// module chunks = 1 2 3 9 26